export default {
      id: "Icon--review-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--review",
      toString: function () {
        return this.url;
      }
    }